import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=f5d067a6&"
import script from "./Header.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Header.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=f5d067a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports